import {
  loadRemote,
  registerRemotes,
} from '@module-federation/enhanced/runtime';
import type { Remote } from '@module-federation/runtime-core/types';

import { bustUrlCache } from './bustUrlCache';
import {
  API_REMOTE_ENTRY_MARKER,
  registerApiRemoteEntryTimeoutPlugin,
} from '../remote/remoteEntryTimeoutPlugin';

export async function loadRemoteModule<T>({
  module,
  scope,
  url,
  bustRemoteEntryCache,
  version,
}: {
  scope: string;
  url: string;
  module: string;
  bustRemoteEntryCache: boolean;
  version?: string;
}) {
  registerApiRemoteEntryTimeoutPlugin();

  const name = version ? `${scope}@${version}` : scope;
  const remote = {
    name,
    entry: bustRemoteEntryCache ? bustUrlCache(url) : url,
    entryGlobalName: scope,
    [API_REMOTE_ENTRY_MARKER]: true,
  } as Remote & { [API_REMOTE_ENTRY_MARKER]: true };
  registerRemotes([remote], {
    force: bustRemoteEntryCache,
  });

  const loadRemoteRequest = `${name}/${module.replace('./', '')}`;
  const loadedRemote = await loadRemote<T>(loadRemoteRequest);

  if (loadedRemote === null) {
    throw new Error(
      `ExoSkeletonAPI Error: Failed to load remote "${module}" from scope "${name}". Load remote request: "${loadRemoteRequest}"`,
    );
  }

  return loadedRemote;
}
